// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__yy7qP","content":"ManualTimeModal_content__2SeEV"};